<template>
  <component @show-enlarged="showEnlarged" :is="`${node.id}-widget`" :widget="node.data" />
</template>

<script>
  import LayerWidget from '@/components/layoutDesigner/designer/widgets/LayerWidget.vue';
  import TextWidget from '@/components/layoutDesigner/designer/widgets/TextWidget.vue';
  import RichtextWidget from '@/components/layoutDesigner/designer/widgets/RichTextWidget.vue';
  import ClockWidget from '@/components/layoutDesigner/designer/widgets/ClockWidget.vue';
  import ButtonWidget from '@/components/layoutDesigner/designer/widgets/ButtonWidget.vue';
  import ImageWidget from '@/components/layoutDesigner/designer/widgets/ImageWidget.vue';
  import PlaylistWidget from '@/components/layoutDesigner/designer/widgets/PlaylistWidget.vue';
  import AppWidget from '@/components/layoutDesigner/designer/widgets/AppWidget.vue';
  import VideoWidget from '@/components/layoutDesigner/designer/widgets/VideoWidget.vue';
  import PdfWidget from '@/components/layoutDesigner/designer/widgets/PdfWidget.vue';
  import TemplateWidget from '@/components/layoutDesigner/designer/widgets/TemplateWidget.vue';
  import AudioWidget from '@/components/layoutDesigner/designer/widgets/AudioWidget.vue';

  export default {
    name: 'WidgetNode',

    props: {
      node: {
        type: Object,
        default: () => {},
      },
    },

    methods: {
      showEnlarged(w) {
        this.$emit('show-enlarged', w);
      },
    },

    components: {
      AudioWidget,
      ImageWidget,
      LayerWidget,
      TextWidget,
      RichtextWidget,
      ClockWidget,
      ButtonWidget,
      PlaylistWidget,
      AppWidget,
      VideoWidget,
      PdfWidget,
      TemplateWidget,
    },
  };
</script>

<style scoped></style>
